import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LearningResourceCard = ({ resource, onAccess }) => {
  const getResourceIcon = (type) => {
    switch (type) {
      case 'Video':
        return 'Video';
      case 'Article':
        return 'FileText';
      case 'PDF':
        return 'FileDown';
      case 'Interactive':
        return 'Laptop';
      case 'Quiz':
        return 'ClipboardCheck';
      default:
        return 'File';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Video':
        return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-200';
      case 'Article':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200';
      case 'PDF':
        return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-200';
      case 'Interactive':
        return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-200';
      case 'Quiz':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-200';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-all duration-300">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 rounded-lg bg-muted flex items-center justify-center">
          <Icon name={getResourceIcon(resource?.type)} size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <div className="flex items-start justify-between mb-2">
            <h3 className="text-base font-semibold text-foreground line-clamp-2 flex-1">
              {resource?.title}
            </h3>
            <span className={`ml-2 px-2 py-1 rounded text-xs font-medium whitespace-nowrap ${getTypeColor(resource?.type)}`}>
              {resource?.type}
            </span>
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
            {resource?.description}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4 mb-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-1">
          <Icon name="Clock" size={14} />
          <span>{resource?.duration}</span>
        </div>
        <div className="flex items-center gap-1">
          <Icon name="BarChart" size={14} />
          <span>{resource?.level}</span>
        </div>
        {resource?.downloads && (
          <div className="flex items-center gap-1">
            <Icon name="Download" size={14} />
            <span>{resource?.downloads}</span>
          </div>
        )}
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          <Icon name="Star" size={16} className="text-yellow-500 fill-yellow-500" />
          <span className="text-sm font-semibold text-foreground">{resource?.rating}</span>
          <span className="text-xs text-muted-foreground">({resource?.reviews})</span>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onAccess(resource)}
          iconName="ExternalLink"
          iconPosition="right"
        >
          Access
        </Button>
      </div>
    </div>
  );
};

export default LearningResourceCard;